module.exports = __webpack_public_path__ + "static/media/bottom_infographic_desktop.e43b0307.webp";